import _u from './util';
import _v from './vars';
import _t from './templates/templates_t';

let boundCards = [];

function closeCmePopup(e) {
	if ((e.target.id === 'cme-overlay') || (e.target.id === 'cme-popup-close')) {
		_v.cmePopCancelled = true;
		clearTimeout(_v.cmeTimer);
		document.removeEventListener('click', closeCmePopup);
		document.getElementById('cme-overlay').classList.remove("active");
		document.getElementById('cme-popup').classList.remove("active");
		document.querySelector('.pers-body').classList.remove("is-blurred");
		_u.removeElem(document.getElementById('cme-overlay'));
		wmdPageLink('fy-cme_close', e.target);
	}
}

function openCmePopup(element) {
    let popUpData = {};
    popUpData.url = element.getAttribute('data-uri');
    popUpData.imageUrl = element.getAttribute('data-img');
    popUpData.title = element.getAttribute('data-title');
    popUpData.credits = element.getAttribute('data-credits');
	document.addEventListener('click', closeCmePopup);
    document.getElementById('cme-modal').appendChild(_u.strToDom(_t.cmeFeedPopup(popUpData)));
    document.querySelector('.pers-body').classList.add("is-blurred");
    document.getElementById('cme-overlay').classList.add("active");
    document.getElementById('cme-popup').classList.add("active");
    wmdPageLink(element.getAttribute('data-track'), element);
    _v.cmePopCancelled = false;
    _v.cmeTimer = setTimeout(function () {
        if (!_v.cmePopCancelled) {
            document.getElementById('cme-overlay').classList.remove("active");
            document.getElementById('cme-popup').classList.remove("active");
            _u.removeElem(document.getElementById('cme-overlay'));
            document.querySelector('.pers-body').classList.remove("is-blurred");
            location.href = popUpData.url;
        }
    }, 5000);
}

function bindCmeCards() {
	document.querySelectorAll('.pers-feed-item.cme, .pers-article-item.cme, .cme-card-container').forEach(element => {
		if (element.getAttribute('data-id') != null && element.getAttribute('data-id') != '' && boundCards.indexOf(element.getAttribute('data-id')) == -1) {
			boundCards.push(element.getAttribute('data-id'));
			element.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				// Workaround to close share layer without clicking CME link
				if (document.querySelectorAll('.pers-share.active').length > 0) {
					document.querySelectorAll('.pers-share.active').forEach(function (element) {
						element.classList.remove('active');
						element.classList.remove('shared');
					});
					if (_u.qS('.cme-share-layer') != null) {
						_u.qS('.cme-share-layer').classList.remove('active');
					}
				}
				else if (!_v.cmeGliderSwiping) {
					openCmePopup(element);
				}
			});
		}
	});
}

document.addEventListener(_v.initialLoadEvent, bindCmeCards);
document.addEventListener('feedLoaded', bindCmeCards);